module.exports = __webpack_public_path__ + "static/media/cool-emoji-svgrepo-com.2d793b6e.svg";